<template>
  <p v-if="showPassageOfTitle">{{ passageOfTitleStatement }}</p>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CheckoutPassageOfTitle',
  computed: {
    ...mapGetters(['checkoutState', 'settingsVars', 'addressStateData']),
    selectedAddressStateAbbrev() {
      if (this.checkoutState.shipping.selectedAddress) {
        return this.checkoutState.shipping.selectedAddress.state_code
      }
      return null
    },
    showPassageOfTitle() {
      const stateAbbrev = this.selectedAddressStateAbbrev
      if (stateAbbrev) {
        return this.settingsVars.COMPLIANCE_STATE_GROUPS.passage_of_title.includes(
          stateAbbrev
        )
      }
      return false
    },
    passageOfTitleStatement() {
      if (this.checkoutState.placeOrder) {
        return this.checkoutState.placeOrder.passageOfTitleStatement
      }
      return this.cart.passageOfTitleStatement
    },
  },
}
</script>
